import { PropsWithChildren } from 'react';

import { useRecentJiraSite } from '@/templates/software/jira/logged-in/utils/use-recent-jira-site';

import { JiraSiteSkeleton } from './jira-site-skeleton';

export const JiraSiteContainer = ({ children }: PropsWithChildren<{}>) => {
	const { siteName, siteInitials, siteUrl } = useRecentJiraSite();

	if (siteName === '' || siteInitials === '' || siteUrl === '') {
		return <JiraSiteSkeleton />;
	}

	return children;
};
